import { useState, useEffect } from 'react';
import { getFuelPrices } from '../services/api';

let _cached = null;
let _promise = null;

/** Lädt die aktuellen Ø-Spritpreise (Tankerkönig) einmal pro Session — geteilt über alle Karten. */
export default function useFuelPrices() {
  const [prices, setPrices] = useState(_cached);

  useEffect(() => {
    if (_cached) return;
    if (!_promise) {
      _promise = getFuelPrices()
        .then((r) => { _cached = r.data; return _cached; })
        .catch(() => null);
    }
    let alive = true;
    _promise.then((d) => { if (alive && d) setPrices(d); });
    return () => { alive = false; };
  }, []);

  return prices;
}
